// Frontend mirror of backend services/exit_rules_helpers.py
// Single source of truth: "is opposite-signal exit enabled for this profile?"

export function isOppositeSignalExitEnabled(exitRules) {
  if (!exitRules) return false;
  const mode = exitRules.mode || exitRules.exit_mode || "";
  if (mode === "opposite_signal") return true;
  if (mode === "combined") return !!exitRules.close_on_opposite_signal;
  // Legacy profiles without `mode`: toggle is authoritative
  if (!mode) return !!exitRules.close_on_opposite_signal;
  // manual / tp_sl / time → never
  return false;
}
